import { stringifyQs } from "@dashboard/utils/urls";

export const whatsappSection = "/whatsapp-campaigns";

export type WhatsAppTab = "campaigns" | "templates";

export interface WhatsAppUrlQueryParams {
  tab?: WhatsAppTab;
  action?: "add" | "send" | "details";
  id?: string;
}

export const whatsappPath = whatsappSection;

export const whatsappUrl = (params?: WhatsAppUrlQueryParams) =>
  whatsappPath + (params ? "?" + stringifyQs(params) : "");
